const TextField = () => {
    return (
        <div className="w-full h-9 bg-gray-200 animate-pulse rounded-sm"></div>
    )
}

export default TextField
